var map = {
	"./british-white-cattle-society-journal-2025-1.webp": 4679,
	"./british-white-cattle-society-journal-2025-2.webp": 422,
	"./british-white-cattle-society-journal-2025-3.webp": 5265,
	"./british-white-cattle-society-journal-2025-4.webp": 8280,
	"./cleft-stick-summer-2024-1.webp": 8076,
	"./cleft-stick-summer-2024-2.webp": 6398,
	"./cleft-stick-summer-2024-3.webp": 5497,
	"./meet-the-farmers.webp": 9463,
	"./on-your-farm.webp": 3913,
	"./world-leather-august-2024-1.webp": 4690,
	"./world-leather-august-2024-2.webp": 8467,
	"./world-leather-august-2024-3.webp": 4624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8725;